import React, { useEffect } from 'react';
import './LandingPage.css';

const LandingPage = ({ onLoginClick }) => {
  // Initialize particles.js
  useEffect(() => {
    // Load particles.js script
    const particlesScript = document.createElement('script');
    particlesScript.src = 'https://cdn.jsdelivr.net/npm/particles.js@2.0.0/particles.min.js';
    particlesScript.async = true;
    document.body.appendChild(particlesScript);

    // Initialize particles.js after script is loaded
    particlesScript.onload = () => {
      if (window.particlesJS) {
        window.particlesJS("particles-js", {
          particles: {
            number: {
              value: 80,
              density: {
                enable: true,
                value_area: 800
              }
            },
            color: {
              value: "#00ffff"
            },
            shape: {
              type: "circle",
              stroke: {
                width: 0,
                color: "#000000"
              },
              polygon: {
                nb_sides: 5
              }
            },
            opacity: {
              value: 0.5,
              random: false,
              anim: {
                enable: false
              }
            },
            size: {
              value: 3,
              random: true,
              anim: {
                enable: false
              }
            },
            line_linked: {
              enable: true,
              distance: 150,
              color: "#00ffff",
              opacity: 0.4,
              width: 1
            },
            move: {
              enable: true,
              speed: 2,
              direction: "none",
              random: false,
              straight: false,
              out_mode: "out",
              bounce: false
            }
          },
          interactivity: {
            detect_on: "canvas",
            events: {
              onhover: {
                enable: true,
                mode: "repulse"
              },
              onclick: {
                enable: true,
                mode: "push"
              },
              resize: true
            },
            modes: {
              grab: {
                distance: 400,
                line_linked: {
                  opacity: 1
                }
              },
              bubble: {
                distance: 400,
                size: 40,
                duration: 2,
                opacity: 8,
                speed: 3
              },
              repulse: {
                distance: 200,
                duration: 0.4
              },
              push: {
                particles_nb: 4
              },
              remove: {
                particles_nb: 2
              }
            }
          },
          retina_detect: true
        });
      }
    };

    // Clean up script when component unmounts
    return () => {
      if (document.body.contains(particlesScript)) {
        document.body.removeChild(particlesScript);
      }
    };
  }, []);

  // Function to connect wallet
  const connectWallet = async () => {
    if (typeof window.ethereum !== 'undefined') {
      try {
        const accounts = await window.ethereum.request({ method: 'eth_requestAccounts' });
        alert('Connected account: ' + accounts[0]);
      } catch (error) {
        alert('Connection error: ' + error.message);
      }
    } else {
      alert('Please install MetaMask!');
    }
  };

  return (
    <div className="landing-page">
      <header>
        <h1>VDEX</h1>
        <nav>
          <a href="#trading">Trading</a>
          <a href="#exchange">Crypto Exchange</a>
          <a href="#swap">Swap</a>
          <a href="#login" onClick={(e) => { e.preventDefault(); onLoginClick(); }}>Login/Signup</a>
        </nav>
      </header>

      <section className="hero">
        <div id="particles-js"></div>
        <div className="hero-content">
          <h2>Your Crypto Wallet<br />Secure. Beautiful. Powerful.</h2>
          <p>Manage and exchange your crypto securely from your desktop or mobile device.</p>
          <a href="#download"><button className="download-button">Download VDEX</button></a>
          <div className="wallet-connect">
            <button onClick={connectWallet} className="connect-button">Connect Wallet</button>
          </div>
        </div>
      </section>
    </div>
  );
};

export default LandingPage;
